import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import Transition from '@ember/routing/-private/transition';
import AccountService from 'cio/services/account';
import IndexController from 'cio/pods/settings/personal/security/index/controller';
import UserModel from 'cio/models/user';

export default class IndexRoute extends Route {
  @service account!: AccountService;

  model() {
    let account = this.account.current;

    return account.belongsTo('currentUser').value();
  }

  setupController(controller: IndexController, model: UserModel | null, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.setDefaults();
  }
}
